import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import styles from './Header.module.css';
import { useNavigate } from 'react-router-dom';
import * as actions from '../store/actions/GlobalActions';
import { useDispatch } from 'react-redux';
import { IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import axios from '../util/Axios';

export default function Header({ logged, drawerToggle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    axios.post('/users/logout').then(() => {
      localStorage.clear();
      dispatch({ type: actions.LOGOUT });
      navigate('/login', { replace: true });
    });
  };

  return (
    <div className={logged === 'true' ? styles.margin : ''}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          {logged === 'true' ? (
            <Toolbar variant="dense">
              <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={drawerToggle} sx={{ mr: 2, display: { sm: 'none' } }}>
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1, paddingLeft: 1 }}>
                Fast AI
              </Typography>
              <Button color="inherit" onClick={() => logout()}>
                Logout
              </Button>
            </Toolbar>
          ) : (
            <Toolbar variant="dense" className={styles.singleItemToolbar}>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1, paddingLeft: 1 }}>
                Fast AI
              </Typography>
            </Toolbar>
          )}
        </AppBar>
      </Box>
    </div>
  );
}
